import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import { AuthContextProvider } from "./../Contexts/authContext";
import GuardedRoute from "./GuardedRoute";
import routesConfig from "./Route";
import FrameLayout from "../Core/FrameLayouts/FrameLayout";
import { ToastCloseButton } from '../Components/base/Toasts';

function Routers() {
  return (
    <AuthContextProvider>
      <Router>
        <ToastContainer closeButton={ToastCloseButton} toastClassName='toast show' />
        <Routes>
          {routesConfig.map((route, i) => (
            <Route
              key={i}
              path={route.path}
              element={
                <GuardedRoute access={route.access}>
                  {route.layout === "frame" ? (
                    <FrameLayout>{route.element}</FrameLayout>
                  ) : (
                    route.element
                  )}
                </GuardedRoute>
              }
            />
          ))}
        </Routes>
      </Router>
    </AuthContextProvider>
  );
}

export default Routers;
